import React, { useState } from 'react';
import { useNavigate, useSearchParams, Link } from 'react-router-dom';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { api } from '@/lib/api';
import { toast } from 'sonner';
import PasswordInput from '@/components/marketplace/PasswordInput';

const ResetPassword = () => {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState('');
  const [pw2, setPw2] = useState('');
  const [loading, setLoading] = useState(false);
  const token = params.get('token') || '';

  const submit = async (e) => {
    e.preventDefault();
    if (!pw || pw.length < 6) return toast.error('Password too short');
    if (pw !== pw2) return toast.error('Passwords do not match');
    setLoading(true);
    try {
      await api.post('/auth/password/confirm', { token, new_password: pw });
      toast.success('Password reset. Please sign in.');
      navigate('/login');
    } catch (e) { toast.error(e?.response?.data?.detail || 'Reset failed'); }
    finally { setLoading(false); }
  };

  return (
    <div className='min-h-[80vh] indus-container py-10 flex items-center justify-center'>
      <Card className='w-full max-w-md p-8'>
        <h1 className='text-xl font-semibold'>Reset your password</h1>
        <p className='text-sm text-muted-foreground mt-1'>Enter a new password below.</p>
        {!token ? (
          <div className='mt-6 p-4 rounded-lg bg-secondary text-sm'>
            Missing token. <Link to='/forgot-password' className='text-primary hover:underline'>Request a new link</Link>.
          </div>
        ) : (
          <form onSubmit={submit} className='mt-6 space-y-3'>
            <div><Label>New password</Label><PasswordInput data-testid='reset-pw' value={pw} onChange={(e) => setPw(e.target.value)} autoComplete='new-password' /></div>
            <div><Label>Confirm password</Label><PasswordInput data-testid='reset-pw2' value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete='new-password' /></div>
            <Button type='submit' className='w-full' disabled={loading} data-testid='reset-submit'>{loading ? 'Resetting…' : 'Reset password'}</Button>
          </form>
        )}
      </Card>
    </div>
  );
};

export default ResetPassword;
